import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.company.data');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ClassicEditor, CKEditorPlugins } from "src/libs/portal/season/ckeditor";
import $ from 'jquery';
import moment from 'moment';

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-company-data',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.company.data/view.scss */
/* src/app/portal.lpsysadmin.widget.company.data/view.scss: no such file or directory */`],
})
export class PortalLpsysadminWidgetCompanyDataComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    @Input() company: any;
    @Input() dataType: string = 'shareholder';
    @ViewChild('boardEditorEl') boardEditorRef: ElementRef;
    // chart.js의 임포트가 불가해서 일단 보류
    //@ViewChild('financialChartCanvas') chartCanvasRef: ElementRef;

    // 공통
    public items: any = [];
    public editingItem: any = null;
    public userMap: any = {};

    // 주주명부
    public totalShares: number = 0;
    public snapshots: any = [];
    public selectedSnapshot: any = null;
    public snapshotFileUrl: string = '';

    // 재무제표
    public annualData: any = null;
    public financialYear: number = new Date().getFullYear();
    public financialViewMode: string = 'annual';
    public financialAllQuarters: any = [];
    public financialAllAnnuals: any = [];
    public chartSubMode: string = 'annual';
    public selectedAnnualYear: number | null = null;
    public selectedQuarterYear: number | null = null;
    private chartInstance: any = null;

    // 특허
    public patentFilter: string = '';
    public patentTypeFilter: string = '';

    // 게시판형 (business, tech, overseas)
    public boardPosts: any = [];
    public boardPost: any = null;
    public boardPage: number = 1;
    public boardTotal: number = 0;
    public boardLastPage: number = 1;
    private editor: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.loadData();
    }

    ngOnDestroy() {
        if (this.editor) {
            this.editor.destroy().catch(() => { });
            this.editor = null;
        }
        if (this.chartInstance) {
            this.chartInstance.destroy();
            this.chartInstance = null;
        }
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "", message, cancel, actionBtn: status, action, status
        });
    }

    public get isBoard() {
        return ['business', 'tech', 'overseas'].includes(this.dataType);
    }

    public getUserName(userId: string) {
        if (!userId) return '';
        return this.userMap[userId] || userId;
    }

    // ═══════════════════════════════════════════
    // 데이터 로드
    // ═══════════════════════════════════════════

    public async loadData() {
        if (!this.company?.id) return;

        if (this.isBoard) {
            await this.loadBoardPosts();
            return;
        }

        if (this.dataType === 'shareholder') {
            await this.loadSnapshots();
            return;
        }

        if (this.dataType === 'financial') {
            await this.loadFinancialData();
            return;
        }

        const params: any = { company_id: this.company.id, data_type: this.dataType };
        if (this.dataType === 'patent') {
            params.status = this.patentFilter;
            params.patent_type = this.patentTypeFilter;
        }
        const { code, data } = await wiz.call("load", params);
        if (code === 200) {
            this.items = data.rows || [];
            if (data.user_map) Object.assign(this.userMap, data.user_map);
        }
        await this.service.render();
    }

    // ═══════════════════════════════════════════
    // 재무제표 - 뷰 모드 전환
    // ═══════════════════════════════════════════

    public async loadFinancialData() {
        await this.loadFinancialsAll();
        await this.service.render();
        /*if (this.financialViewMode === 'chart') {
            setTimeout(() => this.renderChart(), 200);
        }*/
    }

    public async setFinancialViewMode(mode: string) {
        this.financialViewMode = mode;
        this.selectedAnnualYear = null;
        this.selectedQuarterYear = null;
        await this.loadFinancialData();
    }

    public async loadFinancialsAll() {
        const { code, data } = await wiz.call("load_financials_all", { company_id: this.company.id });
        if (code === 200) {
            this.financialAllQuarters = data.quarters || [];
            this.financialAllAnnuals = data.annuals || [];
            if (data.user_map) Object.assign(this.userMap, data.user_map);
        }
    }

    public async setChartSubMode(mode: string) {
        this.chartSubMode = mode;
        await this.service.render();
        //setTimeout(() => this.renderChart(), 200);
    }

    public async onAnnualRowClick(year: number) {
        this.selectedAnnualYear = year;
        await this.service.render();
    }

    public get yearQuarters() {
        if (!this.selectedAnnualYear) return [];
        return this.financialAllQuarters.filter((q: any) => q.year === this.selectedAnnualYear);
    }

    public async backToAnnualList() {
        this.selectedAnnualYear = null;
        await this.service.render();
    }

    public async onQuarterYearClick(year: number) {
        this.selectedQuarterYear = year;
        await this.service.render();
    }

    public get quarterYearQuarters() {
        if (!this.selectedQuarterYear) return [];
        return this.financialAllQuarters.filter((q: any) => q.year === this.selectedQuarterYear);
    }

    public async backToQuarterList() {
        this.selectedQuarterYear = null;
        await this.service.render();
    }

    /*private async renderChart() {
        if (!this.chartCanvasRef?.nativeElement) return;
        if (this.chartInstance) {
            this.chartInstance.destroy();
            this.chartInstance = null;
        }

        const ctx = this.chartCanvasRef.nativeElement.getContext('2d');
        const { Chart, registerables } = await import('chart.js');
        Chart.register(...registerables);

        if (this.chartSubMode === 'annual') {
            const annuals = this.financialAllAnnuals;
            if (!annuals || annuals.length === 0) return;
            const labels = annuals.map((a: any) => `${a.year}년`);
            this.chartInstance = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels,
                    datasets: [
                        { label: '매출액', data: annuals.map((a: any) => a.revenue || 0), backgroundColor: 'rgba(59,130,246,0.7)' },
                        { label: '영업이익', data: annuals.map((a: any) => a.operating_income || 0), backgroundColor: 'rgba(16,185,129,0.7)' },
                        { label: '당기순이익', data: annuals.map((a: any) => a.net_income || 0), backgroundColor: 'rgba(245,158,11,0.7)' }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: { legend: { position: 'top' } },
                    scales: {
                        y: {
                            ticks: {
                                callback: (v: any) => {
                                    if (Math.abs(v) >= 1e8) return (v / 1e8).toFixed(0) + '억';
                                    if (Math.abs(v) >= 1e4) return (v / 1e4).toFixed(0) + '만';
                                    return v;
                                }
                            }
                        }
                    }
                }
            });
        } else {
            const quarters = this.financialAllQuarters;
            if (!quarters || quarters.length === 0) return;
            const labels = quarters.map((q: any) => `${q.year} Q${q.quarter}`);
            this.chartInstance = new Chart(ctx, {
                type: 'line',
                data: {
                    labels,
                    datasets: [
                        { label: '매출액', data: quarters.map((q: any) => q.revenue || 0), borderColor: 'rgb(59,130,246)', backgroundColor: 'rgba(59,130,246,0.1)', fill: true, tension: 0.3 },
                        { label: '영업이익', data: quarters.map((q: any) => q.operating_income || 0), borderColor: 'rgb(16,185,129)', backgroundColor: 'rgba(16,185,129,0.1)', fill: true, tension: 0.3 },
                        { label: '당기순이익', data: quarters.map((q: any) => q.net_income || 0), borderColor: 'rgb(245,158,11)', backgroundColor: 'rgba(245,158,11,0.1)', fill: true, tension: 0.3 }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: { legend: { position: 'top' } },
                    scales: {
                        y: {
                            ticks: {
                                callback: (v: any) => {
                                    if (Math.abs(v) >= 1e8) return (v / 1e8).toFixed(0) + '억';
                                    if (Math.abs(v) >= 1e4) return (v / 1e4).toFixed(0) + '만';
                                    return v;
                                }
                            }
                        }
                    }
                }
            });
        }
    }*/

    // ═══════════════════════════════════════════
    // 특허 - 유형 필터
    // ═══════════════════════════════════════════

    public async setPatentTypeFilter(type: string) {
        this.patentTypeFilter = type;
        await this.loadData();
    }

    // ═══════════════════════════════════════════
    // 게시판형 (business / tech / overseas)
    // ═══════════════════════════════════════════

    public async loadBoardPosts(page: number = 1) {
        this.boardPage = page;
        const { code, data } = await wiz.call("load_board_posts", {
            company_id: this.company.id,
            board_type: this.dataType,
            page: this.boardPage,
            dump: 20
        });
        if (code === 200) {
            this.boardPosts = data.rows || [];
            this.boardTotal = data.total || 0;
            this.boardLastPage = data.last_page || 1;
            if (data.user_map) Object.assign(this.userMap, data.user_map);
        }
        await this.service.render();
    }

    public async selectBoardPost(item: any) {
        const { code, data } = await wiz.call("load_board_post", {
            company_id: this.company.id,
            board_type: this.dataType,
            id: item.id
        });
        if (code === 200) {
            this.boardPost = data.post || {};
            if (data.user_map) Object.assign(this.userMap, data.user_map);
        }
        await this.service.render();
        setTimeout(() => this.initEditor(), 100);
    }

    public async newBoardPost() {
        const now = new Date();
        this.boardPost = {
            title: '',
            content: '',
            extra: {},
            year: now.getFullYear(),
            quarter: Math.ceil((now.getMonth() + 1) / 3)
        };
        this.updateBoardTitle();
        await this.service.render();
        setTimeout(() => this.initEditor(), 100);
    }

    public updateBoardTitle() {
        if (!this.boardPost) return;
        let parts: string[] = [];
        if (this.boardPost.year) parts.push(`${this.boardPost.year}년`);
        if (this.boardPost.quarter) parts.push(`${this.boardPost.quarter}분기`);
        if (this.company?.name) parts.push(this.company.name);
        parts.push(this.title);
        this.boardPost.title = parts.join(' ');
    }

    public async saveBoardPost() {
        if (!this.boardPost) return;
        if (this.editor) {
            this.boardPost.content = this.editor.getData();
        }
        const { code, data } = await wiz.call("save_board_post", {
            company_id: this.company.id,
            board_type: this.dataType,
            data: JSON.stringify(this.boardPost)
        });
        if (code !== 200) return this.alert(data?.message || '저장 실패');
        await this.alert('저장되었습니다', 'success');
        this.boardPost = null;
        if (this.editor) {
            this.editor.destroy().catch(() => { });
            this.editor = null;
        }
        await this.loadBoardPosts(this.boardPage);
    }

    public async deleteBoardPost() {
        if (!this.boardPost?.id) return;
        let res = await this.alert("삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        const { code, data } = await wiz.call("delete_board_post", {
            company_id: this.company.id,
            board_type: this.dataType,
            id: this.boardPost.id
        });
        if (code !== 200) return this.alert(data?.message || '삭제 실패');
        this.boardPost = null;
        if (this.editor) {
            this.editor.destroy().catch(() => { });
            this.editor = null;
        }
        await this.loadBoardPosts(this.boardPage);
    }

    public closeBoardPost() {
        this.boardPost = null;
        if (this.editor) {
            this.editor.destroy().catch(() => { });
            this.editor = null;
        }
        this.service.render();
    }

    private initEditor() {
        if (!this.boardEditorRef?.nativeElement) return;
        const element = this.boardEditorRef.nativeElement;
        if ($(element).parent().find(".ck-content").length > 0) return;
        let toolbar = 'heading | bold italic strikethrough underline | blockQuote code | bulletedList numberedList | outdent indent | uploadImage insertTable link codeBlock horizontalLine | specialCharacters'.split(' ');
        ClassicEditor.create(element, {
            toolbar: { items: toolbar, shouldNotGroupWhenFull: true },
            removePlugins: ["MediaEmbedToolbar"],
            plugins: CKEditorPlugins,
            simpleUpload: { uploadUrl: '/file/upload' }
        }).then((ed: any) => {
            this.editor = ed;
            if (this.boardPost?.content) {
                ed.setData(this.boardPost.content);
            }
        });
    }

    public boardPageChange(page: number) {
        this.loadBoardPosts(page);
    }

    public boardPostYearQuarter(item: any) {
        if (!item.year) return '';
        let label = `${item.year}년`;
        if (item.quarter) label += ` ${item.quarter}분기`;
        return label;
    }

    // ═══════════════════════════════════════════
    // 주주명부 스냅샷
    // ═══════════════════════════════════════════

    public async loadSnapshots() {
        const { code, data } = await wiz.call("load_snapshots", { company_id: this.company.id });
        if (code === 200) {
            this.snapshots = data.snapshots || [];
            if (data.user_map) Object.assign(this.userMap, data.user_map);
        }
        this.selectedSnapshot = null;
        this.items = [];
        this.totalShares = 0;
        this.snapshotFileUrl = '';
        await this.service.render();
    }

    public async selectSnapshot(snapshot: any) {
        const { code, data } = await wiz.call("load_snapshot_shareholders", {
            company_id: this.company.id,
            snapshot_id: snapshot.id
        });
        if (code === 200) {
            this.selectedSnapshot = data.snapshot;
            this.items = data.rows || [];
            this.totalShares = data.total_shares || 0;
            this.snapshotFileUrl = data.snapshot?.file_url || '';
            if (data.user_map) Object.assign(this.userMap, data.user_map);
        }
        await this.service.render();
    }

    public async createSnapshot() {
        const { code, data } = await wiz.call("create_snapshot", {
            company_id: this.company.id, memo: '', copy_last: true
        });
        if (code !== 200) return this.alert(data?.message || '생성 실패');
        await this.loadSnapshots();
        if (this.snapshots.length > 0) {
            await this.selectSnapshot(this.snapshots[0]);
        }
    }

    public async deleteSnapshot() {
        if (!this.selectedSnapshot) return;
        let res = await this.alert("이 주주명부를 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        const { code, data } = await wiz.call("delete_snapshot", {
            company_id: this.company.id,
            snapshot_id: this.selectedSnapshot.id
        });
        if (code !== 200) return this.alert(data?.message || '삭제 실패');
        await this.alert('삭제되었습니다', 'success');
        await this.loadSnapshots();
    }

    public async uploadShareholderPdf() {
        let files = await this.service.file.select({ accept: '.pdf' });
        if (!files || files.length == 0) return;
        await this.service.loading.show();
        try {
            let fd = new FormData();
            fd.append('upload', files[0]);
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            this.snapshotFileUrl = url;
            const { code, data } = await wiz.call('parse_shareholder_pdf', { file_url: url, company_id: this.company.id });
            if (code == 200 && data.rows && data.rows.length > 0) {
                for (let row of data.rows) {
                    this.items.push({
                        name: row.name || '',
                        share_type: row.share_type || '보통주',
                        share_count: Number(row.share_count) || 0,
                        round: row.round || '',
                        acquired_date: row.acquired_date || '',
                        acquisition_price: Number(row.acquisition_price) || 0,
                        note: row.note || ''
                    });
                }
                this.recalcShareRatio();
                await this.alert(`PDF에서 ${data.rows.length}건의 주주 데이터를 추출했습니다.`, 'success');
            } else {
                await this.alert('PDF에서 주주 데이터를 자동으로 추출하지 못했습니다.', 'error');
            }
        } catch (e) {
            await this.alert('PDF 업로드 실패', 'error');
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async saveSnapshotShareholders() {
        if (!this.selectedSnapshot) return;
        if (!this.selectedSnapshot.editable) {
            return this.alert('24시간이 지나 수정할 수 없습니다.');
        }
        const items = this.items.map((r: any) => ({
            id: r.id || '',
            name: r.name,
            share_type: r.share_type,
            share_count: Number(r.share_count) || 0,
            round: r.round || '',
            acquired_date: r.acquired_date || '',
            acquisition_price: Number(r.acquisition_price) || 0,
            note: r.note || ''
        }));
        const { code, data } = await wiz.call("save_snapshot_shareholders", {
            company_id: this.company.id,
            snapshot_id: this.selectedSnapshot.id,
            data: JSON.stringify(items),
            file_url: this.snapshotFileUrl || ''
        });
        if (code !== 200) return this.alert(data?.message || '저장 실패');
        await this.alert('저장되었습니다', 'success');
        await this.selectSnapshot(this.selectedSnapshot);
        const res = await wiz.call("load_snapshots", { company_id: this.company.id });
        if (res.code === 200) {
            this.snapshots = res.data.snapshots || [];
            if (res.data.user_map) Object.assign(this.userMap, res.data.user_map);
        }
        await this.service.render();
    }

    // ═══════════════════════════════════════════
    // 공통 CRUD (financial, patent, support, workforce)
    // ═══════════════════════════════════════════

    public async save(item: any) {
        const { code, data } = await wiz.call("save", {
            company_id: this.company.id,
            data_type: this.dataType,
            data: JSON.stringify(item)
        });
        if (code !== 200) return this.alert(data?.message || '저장 실패');
        this.editingItem = null;
        await this.loadData();
    }

    public async saveAll() {
        if (this.dataType === 'shareholder') {
            return this.saveSnapshotShareholders();
        }
        const items = this.items.map((r: any) => ({ ...r }));
        const { code, data } = await wiz.call("save_all", {
            company_id: this.company.id,
            data_type: this.dataType,
            data: JSON.stringify(items)
        });
        if (code !== 200) return this.alert(data?.message || '저장 실패');
        await this.alert('저장되었습니다', 'success');
        await this.loadData();
    }

    public async remove(id: string) {
        let res = await this.alert("삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("remove", { company_id: this.company.id, data_type: this.dataType, id });
        await this.loadData();
    }

    public addItem() {
        const templates: any = {
            shareholder: { name: '', share_type: '보통주', share_count: 0, round: '', acquired_date: '', acquisition_price: 0, note: '' },
            financial: {
                year: this.financialYear, quarter: 1,
                total_assets: 0, total_liabilities: 0, total_equity: 0,
                current_assets: 0, non_current_assets: 0,
                current_liabilities: 0, non_current_liabilities: 0,
                revenue: 0, cost_of_sales: 0, gross_profit: 0,
                sga_expenses: 0, operating_income: 0, net_income: 0,
                note: '', file_url: ''
            },
            patent: { title: '', application_number: '', application_date: '', registration_date: '', status: 'applied', patent_type: 'domestic', country: '', note: '' },
            support: { title: '', content: '', agency: '', amount: 0, start_date: '', end_date: '', note: '' },
            workforce: { executive_count: 0, employee_count: 0, base_date: '', note: '' }
        };
        if (this.dataType === 'shareholder') {
            this.items.push(templates[this.dataType]);
            this.service.render();
            return;
        }
        this.editingItem = templates[this.dataType] || {};
        this.service.render();
    }

    public removeRow(index: number) {
        this.items.splice(index, 1);
        if (this.dataType === 'shareholder') this.recalcShareRatio();
        this.service.render();
    }

    public recalcShareRatio() {
        const total = this.items.reduce((sum: number, r: any) => sum + (Number(r.share_count) || 0), 0);
        this.totalShares = total;
        for (let r of this.items) {
            r.share_ratio = total > 0 ? Math.round((Number(r.share_count) || 0) / total * 10000) / 100 : 0;
        }
    }

    public editItem(item: any) {
        this.editingItem = JSON.parse(JSON.stringify(item));
        this.service.render();
    }

    public cancelEdit() {
        this.editingItem = null;
        this.service.render();
    }
    public async uploadFinancialFile() {
        let files = await this.service.file.select();
        if (!files || files.length == 0) return;
        await this.service.loading.show();
        try {
            let fd = new FormData();
            fd.append('upload', files[0]);
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            this.editingItem.file_url = url;
        } catch (e) {
            await this.alert('파일 업로드 실패', 'error');
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }
    // ═══════════════════════════════════════════
    // 포맷터/유틸
    // ═══════════════════════════════════════════

    public formatDate(d: any) {
        if (!d) return '';
        return moment(d).format('YYYY-MM-DD HH:mm');
    }

    public formatDateShort(d: any) {
        if (!d) return '';
        return moment(d).format('YYYY-MM-DD');
    }

    public formatNumber(n: any) {
        if (n == null || n == undefined) return '0';
        return Number(n).toLocaleString();
    }

    public statusLabel(status: string, type: string = '') {
        const labels: any = {
            patent: { applied: '출원중', registered: '등록', rejected: '거절' },
            support: { active: '수행중', completed: '완료' }
        };
        return labels[type]?.[status] || status;
    }

    public supportStatusClass(status: string) {
        if (status === 'active') return 'bg-emerald-100 text-emerald-700';
        if (status === 'completed') return 'bg-zinc-100 text-zinc-500';
        return 'bg-zinc-100 text-zinc-500';
    }

    public patentTypeLabel(type: string) {
        if (type === 'domestic') return '국내';
        if (type === 'overseas') return '해외';
        return type;
    }

    public get title() {
        const titles: any = {
            shareholder: '주주명부', financial: '재무제표', patent: '특허현황',
            business: '사업현황', tech: '기술개발현황', support: '지원사업현황',
            workforce: '인력현황', overseas: '해외진출현황'
        };
        return titles[this.dataType] || '';
    }
}

export default PortalLpsysadminWidgetCompanyDataComponent;